export default {
    name: '教研管理',
    // permissionsKey:"",
    permissionsKey:"YY-JYGL",
    icon: 'el-icon-s-shop',
    children: {
        souceList:{
            name: '音视频',
            permissionsKey: 'YY-JYGL-YSP',
            // permissionsKey:"",
            path: '/resources/index',
        },
        checkedTest: {
            name: '题库',
            permissionsKey: 'YY-JYGL-TK',
            // permissionsKey:"",
            path: '/testBaseManage/checkedTest',
        },
        testPaper: {
            name: '试卷',
            permissionsKey: 'YY-JYGL-SJ',
            // permissionsKey:"",
            path: '/examinationPaper/testPaper',
        },
        knowledgeList: {
            name: '知识点',
            permissionsKey: 'YY-JYGL-ZSD',
            // permissionsKey:"",
            path: '/knowledge/knowledgeList',
        },
        curriculum: {
            name: '课程',
            permissionsKey: 'YY-JYGL-KC',
            // permissionsKey:"",
            path: '/resources/curriculum',
        },
        examineList: {
            name: '审核列表',
            permissionsKey: 'YY-JYGL-SH',
            // permissionsKey:"",
            path: '/audit',
        },
        setting: {
            name: "分类设置",
            permissionsKey: "YY-JYGL-FL",
            // permissionsKey:"",
            path: "/classification"
        }
    }
};
